import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// 長い書類でも、一度に確保する画像のメモリが増え続けないようにする。
const MAX_CANVAS_PIXELS = 4_000_000;
const MAX_CANVAS_SIDE = 8192;

export const getPdfCaptureScale = (width, height, preferredScale = 1.3) => {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    throw new Error('PDF出力対象のサイズを取得できませんでした');
  }
  return Math.min(
    preferredScale,
    Math.sqrt(MAX_CANVAS_PIXELS / width / height),
    MAX_CANVAS_SIDE / width,
    MAX_CANVAS_SIDE / height
  );
};

export const saveElementPdf = async (element, filename, { scale = 1.3, paginate = true } = {}) => {
  const width = Math.ceil(Math.max(element.scrollWidth, element.offsetWidth));
  const height = Math.ceil(Math.max(element.scrollHeight, element.offsetHeight));
  let canvas;
  try {
    canvas = await html2canvas(element, {
      width,
      height,
      scale: getPdfCaptureScale(width, height, scale),
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
    });
    const imageHeight = canvas.height * 210 / canvas.width;
    const image = canvas.toDataURL('image/jpeg', 0.6);
    // JPEG化後はcanvasのピクセルバッファを解放する。
    canvas.width = 0;
    canvas.height = 0;

    const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4', compress: true });
    pdf.addImage(image, 'JPEG', 0, 0, 210, imageHeight);
    if (paginate) {
      for (let offset = 297; offset < imageHeight; offset += 297) {
        pdf.addPage();
        pdf.addImage(image, 'JPEG', 0, -offset, 210, imageHeight);
      }
    }
    // 保存処理が完了してから、次の書類を生成する。
    await pdf.save(filename, { returnPromise: true });
  } finally {
    if (canvas) {
      canvas.width = 0;
      canvas.height = 0;
    }
  }
};
